import * as actionLoaderTypes from './setupLoaderActionType';

import * as thematicsAction from '../Thematics/thematicsActions';
import * as editionsAction from '../Editions/editionsActions';
import * as articleAction from '../Article/articleActions';

import SingletonLibrary from '../../library/SingletonLibrary';

export const setupInit = () => {
    return (dispatch, getState) => {
        dispatch(setupInProgress()); 
        
        SingletonLibrary
            .getAxiosInstance
            .get('/setup')
            .then((result) => {
                const response = ( result.error !== true && typeof result.data.response !== 'undefined' )?  
                    result.data.response : null ;
                
                if( response !== null ) {
                    //-- Checks
                    //-- If we haven't edition yet.
                    if ( response.currentEdition.length === 0 ) {
                        const error = new Error("Aucune édition n'est disponible actuellement.");
                        error.response = { status : 404, statusText : "Aucune édition n'est disponible actuellement." }
                        throw error;
                    }
                    //-- If we haven't thematic yet.
                    if ( response.allThematics.length === 0 ) {
                        const error = new Error("Aucune thématique n'est programmé.");
                        error.response = { status : 404, statusText : "Aucune thématique n'est programmé." }
                        throw error;
                    }
                    
                    //-- Set all thematics
                    dispatch(thematicsAction.setThematics(response.allThematics));

                    //-- XHR request to Firebase : Get all reaction for current edition
                    dispatch(articleAction.getAllArticleReactionsByEdition(response.currentEdition.slug));

                    //-- Previous, current, next
                    dispatch(editionsAction.setEditions([response.previousEdition], response.currentEdition));
                    
                    dispatch(setupSuccess()); 
                }
            })
            .catch((e) => {
                const errorCode = ( typeof e.response !== 'undefined' && e.response.status ) || 0;
                const errorMessage = ( typeof e.response !== 'undefined' && e.response.statusText ) || 'Erreur inattendue';
               
                dispatch(setupFailed(errorMessage, errorCode)); 
            });

    }
}

export const setupInProgress = () => {
    return {
        type: actionLoaderTypes.SETUP_IN_PROGRESS
    }
}

export const setupSuccess = () => {
    return {
        type: actionLoaderTypes.SETUP_SUCCESS
    }
}

export const setupFailed = (  errorMessage, errorCode ) => {
    return {
        type: actionLoaderTypes.SETUP_FAILED,
        errorMessage,
        errorCode
    }
}



// WEBPACK FOOTER //
// ./src/components/SetupLoader/setupLoaderActions.js